// md 断点取自 tailwind.config.ts 的 theme.screens.md（864px）。此处内联常量，
// 避免 import 整份 tailwind.config——那会把 @tailwindcss/typography 等构建期插件
// 及其 postcss 依赖（约 76KB）打进几乎所有路由的客户端首屏 chunk。
const MD_BREAKPOINT = '864px'

export function getTranslateFromElement(ele: HTMLElement) {
  const style = window.getComputedStyle(ele)
  const matrix = new DOMMatrixReadOnly(style.transform)

  return {
    translateX: matrix.m41,
    translateY: matrix.m42,
  }
}

// 使用window.matchMedia()来检查当前屏幕宽度
export const isMobileVersion = (): boolean => {
  if (typeof window === 'undefined') {
    return true
  }
  const matchMobile = window.matchMedia(
    `not all and (min-width: ${MD_BREAKPOINT})`
  )
  return matchMobile.matches
}
